import { FILTER_CUSTOMERS } from "../actionTypes";
import { fetchFilteredCustomers } from "../../../api/userManagement/getAllCustomerList.service";

const request = () => ({ type: FILTER_CUSTOMERS.REQUEST });
const failure = (error) => ({ type: FILTER_CUSTOMERS.FAILURE, error });
const success = (data) => ({ type: FILTER_CUSTOMERS.SUCCESS,data});

export const getFilteredCustomers = () => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchFilteredCustomers()
      .then((res) => {
        let obj={
            'data':res.data,
        } 
        dispatch(success(obj));
        return Promise.resolve(true);

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};
